import { Component, OnInit, Input } from '@angular/core';

// <field-ctn [background]="'yellow'">
// if passed attribute: blue, orange or any string

@Component({
  selector: 'field-ctn',
  templateUrl: './field-ctn.component.html',
  styles: [`
  .form-bubble {
    padding: 10px 10px 5px 10px;
    -webkit-border-radius: 8px; 
    -moz-border-radius: 8px; 
    border-radius: 8px;
    position: relative;
  }
    `]
})
export class FieldCtnComponent implements OnInit {

  bgColor:string;
  @Input() background: string = 'blue';

  ngOnInit() {

    switch (this.background) {
        case 'blue':
            this.bgColor = '#f3f6fa';
        break;
        case 'orange':
            this.bgColor = '#FFE7DB';
        break;
        default:
            this.bgColor = this.background;
        break;
    }
  }

}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/field-ctn/field-ctn.component.ts